import { render, staticRenderFns } from "./one-column.vue?vue&type=template&id=bb227378&scoped=true&"
import script from "./one-column.vue?vue&type=script&lang=js&"
export * from "./one-column.vue?vue&type=script&lang=js&"
import style0 from "./one-column.vue?vue&type=style&index=0&id=bb227378&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb227378",
  null
  
)

export default component.exports